var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"pa-0 ma-0",attrs:{"cols":"12"}},[_c('DashboardWidget',{ref:"refDashboardWidget",on:{"leave":_vm.routeLeaveAction}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }